import moment from 'moment';
import {
    TO_TRANSMITED_SHIPMENT_FAILS,
    GET_LIST_CHANNEL_SHIPMENT_SUCCESS,
    TOGGLE_DATA_EXPORT_VISIBILITY
} from './../actions/shipmentAction';
import { SHIPPER_INFOR_SUCCESS } from './../actions/shipperInfor';
import { handlePrintPreview, checkIsChildArr } from './../services/helper';
import { dialogError } from './../services/dialog';
import { shipmentStatus, StatusFilterShipment, FulfillOption as FulfullOptionConst } from "./../constants";
import { ADD_ORDER_FROM_SHIPMENT_SUCCESS } from './../actions/editOrder'
import { CLEAR_FEED_FAILURE, CLEAR_FEED_SUCCESS, ON_CLEAR_FEED } from './../actions/shipmentAction';

const initState = {
    input_filter: {
        status_list: [shipmentStatus.AWAITING_PACKAGE_INFO],
        type_list: [],
        channel: []
    },
    sub_input_filter: {
        status_list: [shipmentStatus.AWAITING_PACKAGE_INFO],
        type_list: [],
        channel: [],
        maxTagCount: 2
    },
    package_info: {
        pgw: undefined,
        pgw_unit: "LBS",
        l: undefined,
        w: undefined,
        h: undefined,
        lwh_unit: "INCH",
        st: "K",
        shiper_st: undefined,
        pvw: 0,
        pvw_display: 0,
        crkc: 0,
        crki: 0,
        crlc: 0,
        crli: 0,
    },
    shipments: [],
    orderBy: 'LastUpdateDT',
    isDesc: true,
    checkedShipments: [],
    listIdCheckedShipments: [],
    listIdCheckedShipmentsWithStatus: {},
    listIdCheckedShipmentsWithChannelId: {},
    getting_order: false,
    ready_to_print: false,
    isCheckedAll: false,
    error_package_info_has_info: false,
    error_package_info_cannot_edit: false,
    add_package_info: false,
    offset: 50,
    current_page: 1,
    pages: 0,
    add_filter: false,
    claer_feed_success: false,
    claer_feed_failure: false,
    loading: false,
    filter_count_status: {
        1: undefined,
        2: undefined,
        3: undefined,
        4: undefined,
        5: undefined,
        6: undefined,
    },
    filter_count_type: {
        1: undefined,
        2: undefined,
    },
    active_tab: "1",
    status_list: [],
    listChannel: [],
    dataExportModalVisibility: false,
    ReadyToPrintCount: 0,
    ReadyToTransmitCount: 0,
    TransmitFailCount: 0,
    shipperInformation: {}
}

// Fix padding when on/off filter
const letSticky = () => {
    let header = document.getElementById("box-utility-shipments");
    let topHeight = document.getElementById("header").clientHeight;
    // Get the offset position of the navbar
    let sticky = header.offsetTop;
    return { header, topHeight, sticky }
}

// Fix padding when off filter
const removeFilter = () => {
    if (window.pageYOffset > letSticky().sticky + letSticky().topHeight) {
        letSticky().header.classList.add("sticky");
        letSticky().header.classList.remove("sticky-filter");
    }
}

// Fix padding when on filter
const addFilter = () => {
    if (window.pageYOffset > letSticky().sticky + letSticky().topHeight) {
        letSticky().header.classList.add("sticky-filter");
        letSticky().header.classList.remove("sticky");
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_FULFILLMENT_OPTION':
            return {
                ...state,
                fulfillment_option: action.payload
            }
        case 'ON_LOAD_SHIPMENT':
            return { ...state, shipments: action.payload }
        case 'ADD_FILTER_SHIPMENT': {
            if (!state.add_filter) {
                removeFilter()
                let copy = { ...state }
                return {
                    ...state,
                    add_filter: true,
                }
            } else {
                document.body.scrollTop = 0; // For Safari
                document.documentElement.scrollTop = 0;
                addFilter()
                let copy = { ...state }
                return {
                    ...state,
                    add_filter: false,
                }
            }
        }
        case 'CLOSE_FILTER_SHIPMENT': {
            removeFilter()
            let copy = { ...state }
            return {
                ...state,
                add_filter: false,
            }
        }
        case 'ON_CHANGE_FILTER_SHIPMENT': {
            let copy = { ...state }
            let result = {
                ...state,
                sub_input_filter: {
                    ...copy.sub_input_filter,
                    [action.payload.column]: action.payload.value,
                },
            }
            return result
        }
        case 'ON_SUBMIT_SHIPMENT': {
            let copy = { ...state }
            if (action.payload.isKeepState) {
                return {
                    ...state,
                    getting_order: true,
                    input_filter: copy.sub_input_filter,
                }
            } else if (action.payload.isChangeOffset) {
                return {
                    ...state, getting_order: true, input_filter: copy.input_filter
                }
            } else if (action.payload.fromQS) {
                return {
                    ...state, getting_order: true, input_filter: { ...copy.input_filter, status_list: [] }
                }
            } else {
                return {
                    ...state,
                    getting_order: true,
                    isDesc: true,
                    orderBy: 'LastUpdateDT',
                    current_page: 1,
                    input_filter: copy.sub_input_filter,
                    listIdCheckedShipments: [],
                }
            }
        }
        case 'ON_SORT_SHIPMENT': {
            let result
            let copy = { ...state }
            let columns = ['ChannelNameCH', 'ChannelOrderID', 'PackageNumberCH', 'TrackingNumberCH', 'LastUpdateDT', 'ShipDateDT', 'ConsigneeCountryCH', 'ConsigneeNameCH', 'StatusCH']

            columns.map(column => {
                if (action.payload.column == column && action.payload.column == copy.orderBy) {
                    result = {
                        ...state,
                        orderBy: column,
                        isDesc: !copy.isDesc,
                        getting_order: true,
                    }
                }
                if (action.payload.column == column && action.payload.column != copy.orderBy) {
                    result = {
                        ...state,
                        orderBy: column,
                        isDesc: true,
                        getting_order: true,
                    }
                }
            })
            return result
        }
        case 'ON_GET_ORDERS_BY_PAGE': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'GET_SHIPMENT_SUCCESS': {
            let copy = { ...state }
            let newDataOrders = []
            for (let i = 0; i < action.json.data.data.Shipments.length; i++) {
                action.json.data.data.Shipments[i].key = i
                newDataOrders.push(action.json.data.data.Shipments[i])
            }
            for (let i in copy.listIdCheckedShipmentsWithStatus) {
                if (!action.json.data.data.SelectedIds.includes(parseInt(i))) {
                    delete copy.listIdCheckedShipmentsWithStatus[i]
                }
            }

            for (let i in copy.listIdCheckedShipmentsWithChannelId) {
                if (!action.json.data.data.SelectedIds.includes(parseInt(i))) {
                    delete copy.listIdCheckedShipmentsWithChannelId[i]
                }
            }

            const { data } = action.json.data;
            return {
                ...state,
                sub_input_filter: copy.input_filter,
                shipments: newDataOrders,
                getting_order: false,
                pages: action.json.data.data.PageCount,
                shipment_count: action.json.data.data.ShipmentCount,
                current_page: action.json.data.data.CurrentPage,
                checkedShipments: [],
                isCheckedAll: false,
                AwaitingPackageInformationCount: action.json.data.data.AwaitingPackageInformationCount,
                ReadyToPrintCount: action.json.data.data.ReadyToPrintCount ? action.json.data.data.ReadyToPrintCount : 0,
                ReadyToTransmitCount: action.json.data.data.ReadyToTransmitCount ? action.json.data.data.ReadyToTransmitCount : 0,
                ShippedTodayCount: action.json.data.data.ShippedTodayCount ? action.json.data.data.ShippedTodayCount : 0,
                ShippedTodayWithErrorCount: action.json.data.data.ShippedTodayWithErrorCount ? action.json.data.data.ShippedTodayWithErrorCount : 0,
                TransmitFailCount: action.json.data.data.TransmitFailCount,
                TransmittedCountByFilter: data.DeliveredCountByFilter + data.ShippedCountByFilter + data.InTransmitCountByFilter + data.FulfillmentShippingInProcessCountByFilter,
                FulfillmentInProcessCount: action.json.data.data.FulfillmentInProcessCount ? action.json.data.data.FulfillmentInProcessCount : 0,
                FulfillmentCompletedCount: action.json.data.data.FulfillmentCompletedCount ? action.json.data.data.FulfillmentCompletedCount : 0,
                FulfillmentShippingInProcessCount: action.json.data.data.FulfillmentShippingInProcessCount ? action.json.data.data.FulfillmentShippingInProcessCount : 0,
                filter_count_status: {
                    1: action.json.data.data.AwaitingPackageInformationCountByFilter,
                    2: action.json.data.data.ReadyToPrintCountByFilter,
                    3: action.json.data.data.ReadyToTransmitCountByFilter,
                    4: action.json.data.data.ShippedCountByFilter,
                    5: action.json.data.data.InTransmitCountByFilter,
                    6: action.json.data.data.DeliveredCountByFilter,
                    18: action.json.data.data.FulfillmentInProcessCountByFilter,
                    19: action.json.data.data.FulfillmentShippingInProcessCountByFilter,
                    20: action.json.data.data.FulfillmentCompletedCountByFilter,
                },
                filter_count_type: {
                    1: action.json.data.data.ImportCountByFilter,
                    2: action.json.data.data.ManualCountByFilter,
                },
                listIdCheckedShipments: action.json.data.data.SelectedIds,
                listIdCheckedShipmentsWithStatus: copy.listIdCheckedShipmentsWithStatus,
                listIdCheckedShipmentsWithChannelId: copy.listIdCheckedShipmentsWithChannelId,
                filterDate: new Date()
            }
        }
        case 'GET_SHIPMENT_FAILURE': {
            return {
                ...state,
                shipments: [],
                getting_order: false,
                shipment_count: 0,
                filter_count_status: {
                    1: 0,
                    2: 0,
                    3: 0,
                    4: 0,
                    5: 0,
                    6: 0,
                    18: 0,
                    19: 0,
                    20: 0,
                },
                filter_count_type: {
                    1: 0,
                    2: 0,
                }
            }
        }
        case 'ON_CHECK_SHIPMENT': {
            let result
            let copy = { ...state }
            let key = parseInt(Object.keys(action.payload)[0])
            let index = copy.checkedShipments.indexOf(key)
            let isCheckedAll
            let listIdCheckedShipmentsWithStatus = copy.listIdCheckedShipmentsWithStatus
            let listIdCheckedShipmentsWithChannelId = copy.listIdCheckedShipmentsWithChannelId
            listIdCheckedShipmentsWithStatus[action.payload[key]] = copy.shipments[key].StatusID
            listIdCheckedShipmentsWithChannelId[action.payload[key]] = copy.shipments[key].ChannelID
            if (index > -1) {
                delete listIdCheckedShipmentsWithStatus[action.payload[key]]
                delete listIdCheckedShipmentsWithChannelId[action.payload[key]]
                result = {
                    ...state,
                    checkedShipments: copy.checkedShipments.filter(value => value != key),
                    listIdCheckedShipments: copy.listIdCheckedShipments.filter(value => value != parseInt(action.payload[key])),
                    listIdCheckedShipmentsWithStatus: listIdCheckedShipmentsWithStatus,
                    listIdCheckedShipmentsWithChannelId: listIdCheckedShipmentsWithChannelId,
                    isCheckedAll: false
                }
            } else {
                if (copy.checkedShipments.length == copy.shipments.length - 1) {
                    isCheckedAll = true
                }
                else {
                    isCheckedAll = false
                }
                if (copy.listIdCheckedShipments.indexOf(action.payload[key]) > -1) {
                    delete listIdCheckedShipmentsWithStatus[action.payload[key]]
                    delete listIdCheckedShipmentsWithChannelId[action.payload[key]]
                    result = {
                        ...state,
                        checkedShipments: copy.checkedShipments.filter(value => value != key),
                        listIdCheckedShipments: copy.listIdCheckedShipments.filter(value => value != parseInt(action.payload[key])),
                        listIdCheckedShipmentsWithStatus: listIdCheckedShipmentsWithStatus,
                        listIdCheckedShipmentsWithChannelId: listIdCheckedShipmentsWithChannelId,
                        isCheckedAll,
                    }
                } else {
                    result = {
                        ...state,
                        checkedShipments: [...copy.checkedShipments, key],
                        listIdCheckedShipments: [...copy.listIdCheckedShipments, action.payload[key]],
                        listIdCheckedShipmentsWithStatus: listIdCheckedShipmentsWithStatus,
                        listIdCheckedShipmentsWithChannelId: listIdCheckedShipmentsWithChannelId,
                        isCheckedAll,
                    }
                }
            }
            return result
        }
        case 'ON_CHECK_ALL_SHIPMENT': {
            let result
            let copy = { ...state }
            let listIdCheckedShipments = []
            let listIdCheckedShipmentsWithStatus = copy.listIdCheckedShipmentsWithStatus
            let listIdCheckedShipmentsWithChannelId = copy.listIdCheckedShipmentsWithChannelId
            copy.shipments.forEach(shipment => {
                listIdCheckedShipments.push(shipment.PackageID)
                listIdCheckedShipmentsWithStatus[shipment.PackageID] = shipment.StatusID
                listIdCheckedShipmentsWithChannelId[shipment.PackageID] = shipment.ChannelID
            })
            let lists = [...copy.listIdCheckedShipments]
            let isChildArr = checkIsChildArr(copy.listIdCheckedShipments, listIdCheckedShipments)
            if (!isChildArr) {
                lists = [...new Set(lists.concat(listIdCheckedShipments))]
            } else {
                lists.forEach((elm, idx) => {
                    if (listIdCheckedShipments.indexOf(elm) !== -1) {
                        delete lists[idx]
                        delete listIdCheckedShipmentsWithStatus[elm]
                        delete listIdCheckedShipmentsWithChannelId[elm]
                    }
                })
                lists = lists.filter(value => value)
            }
            result = {
                ...state,
                checkedShipments: [],
                isCheckedAll: !isChildArr,
                listIdCheckedShipments: lists,
                listIdCheckedShipmentsWithStatus: listIdCheckedShipmentsWithStatus,
                listIdCheckedShipmentsWithChannelId: listIdCheckedShipmentsWithChannelId,
            }
            return result
        }
        case 'ON_CHANGE_OFFSET_SHIPMENT_LIST': {
            return { ...state, offset: action.payload, current_page: 1 }
        }
        case 'ON_NEXT_OR_BACK_SHIPMENT': {
            let result
            if (action.payload.type == 'back') {
                result = {
                    ...state,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'back-head') {
                result = {
                    ...state,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'next') {
                result = {
                    ...state,
                    getting_order: true,
                }
            }
            if (action.payload.type == 'next-last') {
                result = {
                    ...state,
                    getting_order: true,
                }
            }
            return result
        }
        case 'ON_RESET_SHIPMENT_FILTER': {
            let status_list = action.payload.FulfillmentOption === FulfullOptionConst.YAMATO.CODE ? [shipmentStatus.FULFILLMENT_IN_PROCESS] : [shipmentStatus.AWAITING_PACKAGE_INFO]
            return {
                ...state,
                input_filter: {
                    status_list: status_list,
                    type_list: [],
                    channel: []
                },
                getting_order: true,
                current_page: 1,
                orderBy: 'LastUpdateDT',
                listIdCheckedShipments: [],
                listIdCheckedShipmentsWithStatus: {},
                listIdCheckedShipmentsWithChannelId: {},
            }
        }
        case 'ON_REMOVE_FILTER_ORDER': {
            let result
            let copy = { ...state }
            if (Number.isInteger(action.payload.value)) {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        status_list: copy.input_filter.status_list.filter(a => a !== action.payload.value),
                    },
                }
            }
            if (action.payload.value == 'from') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        from: undefined,
                    },
                }
            }
            if (action.payload.value == 'to') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        to: undefined,
                    },
                }
            }
            if (action.payload.value == 'channel_order_no') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        channel_order_no: undefined,
                    },
                }
            }
            if (action.payload.value == 'channel') {
                result = {
                    ...state,
                    input_filter: {
                        ...copy.input_filter,
                        channel: undefined,
                    },
                }
            }
            return result
        }
        case 'ON_TAB_SHIPMENT': {
            return {
                ...state,
                active_tab: action.payload.tab,
                input_filter: {
                    type_list: [],
                    status_list: parseInt(action.payload.tab) === 4 ? [StatusFilterShipment.SHIPPED, StatusFilterShipment.IN_TRANSIT] : [parseInt(action.payload.tab)],
                    shipping_date_from: parseInt(action.payload.tab) === 4 ? moment().format('MM/DD/YYYY') : undefined,
                    shipping_date_to: parseInt(action.payload.tab) === 4 ? moment().format('MM/DD/YYYY') : undefined,
                },
                getting_order: true,
                orderBy: 'LastUpdateDT',
                isDesc: true,
                listIdCheckedShipments: [],
                listIdCheckedShipmentsWithStatus: {},
                listIdCheckedShipmentsWithChannelId: {},
            }
        }
        case 'CREAT_SHIPMENT_SUCCESS': {
            return {
                ...state,
                create_shipment_success: true,
            }
        }
        case 'CREAT_SHIPMENT_FAILURE': {
            return {
                ...state,
                create_shipment_failure: true,
            }
        }
        case 'ON_OK': {
            let result
            if (action.payload == 'add_failure') {
                result = {
                    ...state,
                    add_package_info_failure: false,
                    error_package_info_has_info: false,
                    error_package_info_cannot_edit: false
                }
            }
            if (action.payload == 'add_success') {
                result = {
                    ...state,
                    add_package_info_success: false,
                    add_package_info: false,
                }
            }
            if (action.payload == 'close-add-package') {
                result = {
                    ...state,
                    add_package_info: false,
                }
            }
            if (action.payload == 'delete') {
                result = {
                    ...state,
                    delete_shipment_success: false,
                    delete_shipment_failure: false,
                }
            }
            if (action.payload == 'trasmitted') {
                result = {
                    ...state,
                    transmited_success: false,
                    transmited_success_data: {},
                    transmited_failure: false,
                }
            }
            if (action.payload === 'clear') {
                result = {
                    ...state,
                    clear_feed_success: false,
                    clear_feed_failure: false,
                }
            }
            if (action.payload == 'printed') {
                result = {
                    ...state,
                    getting_label_info: false,
                }
            }

            return result
        }
        case 'ON_DELETE_SHIPMENT': {
            return {
                ...state,
                getting_order: true,
                delete_shipment_modal: false,
            }
        }
        case 'DELETE_SHIPMENT_SUCCESS': {
            return {
                ...state,
                delete_shipment_success: true,
                delete_shipment_modal: false,
                getting_order: false,
            }
        }
        case 'DELETE_SHIPMENT_FAILURE': {
            return {
                ...state,
                delete_shipment_failure: true,
                delete_shipment_modal: false,
                getting_order: false,
            }
        }
        case ON_CLEAR_FEED: {
            return {
                ...state,
                getting_order: true,
                clear_feed_success: false,
                clear_feed_failure: false,
            }
        }
        case CLEAR_FEED_SUCCESS: {
            return {
                ...state,
                clear_feed_success: true,
                getting_order: false,
            }
        }
        case CLEAR_FEED_FAILURE: {
            return {
                ...state,
                clear_feed_failure: true,
                getting_order: false,
            }
        }
        case 'ON_ADD_PACKAGE_INFO': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'ON_CHANGE_ADD_PACKAGE_INFO': {
            let copy = { ...state }
            let result = {
                ...state,
                package_info: {
                    ...copy.package_info,
                    [action.payload.column]: action.payload.value,
                },
            }
            let pgw_unit = result.package_info.pgw_unit
            let lwh_unit = result.package_info.lwh_unit
            let l = result.package_info.l
            let w = result.package_info.w
            let h = result.package_info.h
            let crlc = result.package_info.crlc
            let crli = result.package_info.crli
            let crkc = result.package_info.crkc
            let crki = result.package_info.crki
            if (pgw_unit === 'LBS') {
                if (lwh_unit === 'CM') {
                    if (result.package_info.crlc > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crlc * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crlc * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                } else if ('INCH') {
                    if (result.package_info.crli > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crli * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crli * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                }
            } else if (pgw_unit === "KGS") {
                if (lwh_unit === 'CM') {
                    if (result.package_info.crkc > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crkc * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crkc * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                } else if ('INCH') {
                    if (result.package_info.crki > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crki * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crki * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                }
            }
            return result
        }
        case 'ON_SUBMIT_PACKAGE_INFO': {
            return {
                ...state,
                on_submit_package_info: true,
            }
        }
        case 'ADD_PACKAGE_INFO_SUCCESS': {
            return {
                ...state,
                on_submit_package_info: false,
                add_package_info_success: true,
                add_package_info: false
            }
        }
        case 'ADD_PACKAGE_INFO_FAILURE': {
            return {
                ...state,
                on_submit_package_info: false,
                add_package_info: false,
            }
        }
        case 'UPDATE': {
            let copy = { ...state }
            return {
                ...state,
                offset: action.payload.offset ? action.payload.offset : copy.offset,
                input_filter: {
                    ...copy.input_filter,
                    status_list: action.payload.input_filter ? action.payload.input_filter.status_list : copy.input_filter.status_list,
                    type_list: action.payload.input_filter ? action.payload.input_filter.type_list : copy.input_filter.type_list,
                    channel_order_no: action.payload.input_filter ? action.payload.input_filter.channel_order_no : copy.input_filter.channel_order_no,
                    channel: action.payload.input_filter ? action.payload.input_filter.channel : copy.input_filter.channel,
                    order_date_from: action.payload.input_filter ? action.payload.input_filter.order_date_from : copy.input_filter.order_date_from,
                    order_date_to: action.payload.input_filter ? action.payload.input_filter.order_date_to : copy.input_filter.order_date_to,
                    shipping_date_from: action.payload.input_filter ? action.payload.input_filter.shipping_date_from : copy.input_filter.shipping_date_from,
                    shipping_date_to: action.payload.input_filter ? action.payload.input_filter.shipping_date_to : copy.input_filter.shipping_date_to,
                    tracking_number_from: action.payload.input_filter ? action.payload.input_filter.tracking_number_from : copy.input_filter.tracking_number_from,
                    tracking_number_to: action.payload.input_filter ? action.payload.input_filter.tracking_number_to : copy.input_filter.tracking_number_to
                },
                add_filter: action.payload.add_filter,
                orderBy: action.payload.orderBy ? action.payload.orderBy : copy.orderBy
            }
        }
        case 'TO_TRANSMITED': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'TO_TRANSMITED_SHIPMENT_SUCCESS': {
            return {
                ...state,
                transmited_success: true,
                transmited_success_data: action.payload.data,
                getting_order: false,
            }
        }
        case 'TO_TRANSMITED_SHIPMENT_FAILURE': {
            return {
                ...state,
                transmited_failure: true,
                getting_order: false,
            }
        }
        case 'GET_LABEL_INFO': {
            return {
                ...state,
                getting_label_info: true,
                loading: true,
                getting_order: true
            }
        }
        case 'GET_LABEL_INFO_SUCCESS': {
            handlePrintPreview(action.payload.data)
            return {
                ...state,
                loading: false,
                label_data: action.payload.data
            }
        }
        case 'GET_LABEL_INFO_NOT_PDF_SUCCESS': {
            return {
                ...state,
                loading: false,
                label_data: action.payload.data
            }
        }
        case 'GET_LABEL_INFO_FAILURE': {
            return {
                ...state,
                getting_label_info: false,
                popup_error: true,
                getting_order: false
            }
        }
        case 'ON_GET_SHIPMENT_BY_PAGE': {
            return {
                ...state,
                getting_order: true,
            }
        }
        case 'GET_PACKAGE_INFO_SUCCESS': {
            let result = {
                ...state,
                package_info: {
                    pgw: action.payload.data.data.PackageInformation[0].GrossWeightFL,
                    pgw_unit: action.payload.data.data.PackageInformation[0].WeightUnitCH.trim(),
                    l: action.payload.data.data.PackageInformation[0].LengthFL,
                    w: action.payload.data.data.PackageInformation[0].WidthFL,
                    h: action.payload.data.data.PackageInformation[0].HeightFL,
                    lwh_unit: action.payload.data.data.PackageInformation[0].LengthUnitCH.trim(),
                    st: action.payload.data.data.PackageInformation[0].ServiceType.trim(),
                    shiper_st: action.payload.data.data.PackageInformation[0].ShipperServiceType.trim(),
                    pvw: action.payload.data.data.PackageInformation[0].VolumeWeightFL,
                    pvw_display: action.payload.data.data.PackageInformation[0].VolumeWeightFL,
                    crkc: action.payload.data.data.PackageInformation[0].CubicRateKgsCm,
                    crki: action.payload.data.data.PackageInformation[0].CubicRateKgsInch,
                    crlc: action.payload.data.data.PackageInformation[0].CubicRateLbsCm,
                    crli: action.payload.data.data.PackageInformation[0].CubicRateLbsInch,
                },
                add_package_info: true,
                getting_order: false,
            }

            let pgw_unit = result.package_info.pgw_unit
            let lwh_unit = result.package_info.lwh_unit
            let l = result.package_info.l
            let w = result.package_info.w
            let h = result.package_info.h
            let crlc = result.package_info.crlc
            let crli = result.package_info.crli
            let crkc = result.package_info.crkc
            let crki = result.package_info.crki
            if (pgw_unit === 'LBS') {
                if (lwh_unit === 'CM') {
                    if (result.package_info.crlc > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crlc * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crlc * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                } else if ('INCH') {
                    if (result.package_info.crli > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crli * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crli * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                }
            } else if (pgw_unit === "KGS") {
                if (lwh_unit === 'CM') {
                    if (result.package_info.crkc > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crkc * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crkc * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                } else if ('INCH') {
                    if (result.package_info.crki > 0) {
                        result.package_info.pvw = Math.round(l * w * h / crki * 10) / 10
                        result.package_info.pvw_display = Math.round(l * w * h / crki * 10) / 10
                    } else {
                        result.package_info.pvw = 0
                        result.package_info.pvw_display = "-"
                    }
                }
            }

            return result
        }
        case 'GET_PACKAGE_INFO_FAILURE': {
            return {
                ...state,
                getting_order: false,
            }
        }
        case TO_TRANSMITED_SHIPMENT_FAILS:
            return {
                ...state,
                getting_order: false
            }

        case 'GET_HEADER_SUMMARY_SUCCESS':
            return {
                ...state,
                ReadyToPrintCount: action.payload.data.data.ReadyToPrint ? action.payload.data.data.ReadyToPrint : 0,
                ReadyToTransmitCount: action.payload.data.data.ReadyToShip ? action.payload.data.data.ReadyToShip : 0,
            }

        case 'GET_HEADER_SUMMARY_SHIPPER_NOT_FOUND': {
            return {
                ...state,
                ReadyToPrintCount: 0,
                ReadyToTransmitCount: 0
            }
        }
        case 'GET_HEADER_SUMMARY_ERROR': {
            return {
                ...state,
                ReadyToPrintCount: 0,
                ReadyToTransmitCount: 0
            }
        }
        case 'RESET_SUMARY_SHIPMENT': {
            return {
                ...state,
                ReadyToPrintCount: 0,
                ReadyToTransmitCount: 0
            }
        }
        case ADD_ORDER_FROM_SHIPMENT_SUCCESS:
            return {
                ...state,
                status_list: action.payload.status_list,
                input_filter: {
                    ...state.input_filter,
                    status_list: action.payload.status_list
                }
            }

        case GET_LIST_CHANNEL_SHIPMENT_SUCCESS:
            return {
                ...state,
                listChannel: action.payload.data.data.channels
            }

        case TOGGLE_DATA_EXPORT_VISIBILITY:
            return {
                ...state,
                dataExportModalVisibility: action.payload.visibility
            }

        case SHIPPER_INFOR_SUCCESS:
            let shipperInfor = action.payload.data.data
            return {
                ...state,
                shipperInformation: {
                    multiPackageFlg: shipperInfor.MultiPackageFlg,
                    currency: shipperInfor.DefaultCurrencyCH,
                    defaultPaymentTerm: shipperInfor.DefaultPaymentTermCH,
                    paymentTerms: shipperInfor.PaymentTermsCH,
                    destinationCountriesCH: shipperInfor.DestinationCountryCH,
                    handlingChargeFlg: shipperInfor.HandlingChargeFlg
                }
            }

        default:
            return state
    }
}
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/shipmentReducer.js